// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"_3prq51KS","tooltipLeftArrow":"_2dOzjGOy","tooltipRightArrow":"En6Jm6kS"};